var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "management-sidebar",
        class: { closed: !_vm.sidebarIsOpen }
      },
      [
        _c(
          "div",
          { staticStyle: { margin: "0 auto" } },
          [
            _c("WeezieLogo", {
              class: _vm.hubButtonClass,
              attrs: { sidebarIsOpen: _vm.sidebarIsOpen },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "hub" })
                }
              }
            }),
            _vm._v(" "),
            _c(
              "md-tooltip",
              {
                staticClass: "return-to-tooltip",
                class: { closed: !_vm.sidebarIsOpen },
                attrs: {
                  "md-direction": _vm.sidebarIsOpen ? "bottom" : "right"
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("BackToHub")) + "\n      ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "management-sidebar-scroll" },
          _vm._l(_vm.menu, function(menuItem) {
            return !menuItem.disabled
              ? _c(
                  "div",
                  { key: menuItem.name },
                  [
                    _vm.sidebarIsOpen
                      ? _c("menu-item", {
                          attrs: { item: menuItem, selected: _vm.selectedMenu },
                          on: {
                            toggle: function($event) {
                              return _vm.toggleMenu($event, menuItem.submenu)
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "icon",
                                fn: function() {
                                  return [
                                    _c(menuItem.icon, {
                                      tag: "component",
                                      style: {
                                        fill: _vm.activeTab(menuItem)
                                          ? "white"
                                          : "black"
                                      },
                                      attrs: { width: "18px" }
                                    })
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "subMenu",
                                fn: function() {
                                  return [
                                    _c(
                                      "transition-group",
                                      {
                                        attrs: { name: "fade", mode: "out-in" }
                                      },
                                      _vm._l(menuItem.submenu, function(
                                        submenuItem
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.activeTab(menuItem),
                                                expression:
                                                  "activeTab(menuItem)"
                                              }
                                            ],
                                            key: submenuItem.name
                                          },
                                          [
                                            (_vm.isSuperAdmin ||
                                              !submenuItem.dev) &&
                                            !submenuItem.disabled
                                              ? _c("sub-menu-item", {
                                                  attrs: {
                                                    item: submenuItem,
                                                    selected:
                                                      _vm.selectedSubMenu,
                                                    disabled:
                                                      submenuItem.disabled
                                                  },
                                                  on: {
                                                    toggle: _vm.toggleSubMenu
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.sidebarIsOpen
                      ? _c(
                          "v-tooltip",
                          {
                            attrs: { right: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "buttonContainer",
                                              class: {
                                                selected: _vm.activeTab(
                                                  menuItem
                                                )
                                              },
                                              attrs: { text: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.toggleSidebar(
                                                    menuItem,
                                                    menuItem.submenu
                                                  )
                                                }
                                              }
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          [
                                            _c(menuItem.icon, {
                                              tag: "component",
                                              style: {
                                                fill: _vm.activeTab(menuItem)
                                                  ? "white"
                                                  : "black"
                                              },
                                              attrs: { width: "18px" }
                                            })
                                          ]
                                        ],
                                        2
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(menuItem.name))])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52c9a94d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52c9a94d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Sidebar/Sidebar.vue
// module id = null
// module chunks = 